import type {DSConfig} from '@wix/document-services-types'
import responsiveConfig from './responsiveConfig'

const config = {
    ...responsiveConfig,
    modulesList: [...responsiveConfig.modulesList],
    extensionsList: [...responsiveConfig.extensionsList],
    experimentalConfigOptions: {
        ...responsiveConfig.experimentalConfigOptions,
        dm_enforceStrictValidationEverywhere: {
            configOptions: {
                enforceStrictValidationEverywhere: true
            }
        }
    }
}

export default config as unknown as DSConfig
